import { routeMappings, WorkflowItemCode } from '../../constants';
import { BasicForm } from '../interfaces/BasicForm';

export enum TaskItemStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETE',
  NOT_STARTED = 'NOT_STARTED',
}

export const FORMS = 'FORMS';
export const defaultFormList: BasicForm[] = [
  {
    id: '1',
    name: 'Application Form',
    duration: 5,
    indicator: 'appFormIndicator',
    link: routeMappings['APPLICATION_FORM'],
    completionIndicator: 'applicationFormSubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
  {
    id: '2',
    name: 'Help SHL’s research',
    duration: 5,
    indicator: 'researchQuestionsIndicator',
    link: routeMappings['RESEARCH_QUESTIONS'],
    completionIndicator: 'researchQuestionSubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
  {
    id: '3',
    name: 'Equal employment opportunity (EEO) self-identification',
    duration: 5,
    indicator: 'eeoIndicator',
    link: routeMappings['EEO'],
    completionIndicator: 'eeoSubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
  {
    id: '4',
    name: 'Voluntary self-identification of disability',
    duration: 5,
    indicator: 'ofccpIndicator',
    link: routeMappings['OFCCP'],
    completionIndicator: 'ofccpSubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
  {
    id: '5',
    name: 'Your Responsibilities',
    duration: 5,
    indicator: 'yourResponsibilityIndicator',
    link: routeMappings['YOUR_RESPONSIBILITY'],
    completionIndicator: 'yourResponsibilitySubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
];
